import { Component } from '@angular/core';

@Component({
  selector: 'app-campain-dropdown',
  templateUrl: './campain-dropdown.component.html',
  styleUrls: ['./campain-dropdown.component.scss']
})
export class CampainDropdownComponent {

}
